import Component from '../core/Component';
import { format, limit, parseInteger } from '../utils/Number';

export default class RangeControl extends Component {
    options = {
        translate: null,
        range: null,
    }

    constructor(element) {
        super(element)

        this.ref = {
            range: null,
            input: null,
            output: null,
        }

        this.error = false
        this.ready = false
        this.optionsQueue = []

        this._data = null
    }

    prepare() {
        this.range = Component.getFromElement(this.ref.range)
        this.range.on('change', this.handleRangeChange)

        this.ready = true

        this.ref.input.addEventListener('change', this.handleInputChange)
        this.ref.input.addEventListener('keyup', this.handleInputKeyup)

        if (this.optionsQueue.length) {
            this.optionsQueue.forEach((options) => this.setOptions(options))
        }
        if (this.ref.input.value) {
            this.ref.input.value = format(parseInteger(this.ref.input.value))
        }
    }

    getValue() {
        const value = this.ref.input.value ? parseInteger(this.ref.input.value) : 0

        if (this.options.translate) {
            return this.options.translate[value]
        }

        return value
    }

    getRange() {
        return this.range.getLimits()
    }

    handleRangeChange = ({ value }) => {
        const formattedValue = format(value)
        this.ref.input.value = formattedValue

        if (this.ref.output) {
            this.ref.output.innerText = formattedValue
        }

        this.emit('change', {
            value: this.options.translate ? this.options.translate[value] : value,
        })
    }

    handleInputKeyup = (event) => {
        event.stopPropagation()
        let value = parseInteger(this.ref.input.value)
        if (this.ref.input.value) {
            this.ref.input.value = format(value)
        }
    }
    handleInputChange = (event) => {
        event.stopPropagation()

        let value = parseInteger(this.ref.input.value)

        this.range.set({
            value: value,
        })

        let resetValue = false

        if (isNaN(value)) {
            resetValue = true
            value = 0
        }

        const limits = this.range.getLimits()

        const limited = limit(value, limits.min, limits.max)

        if (limited !== value) {
            resetValue = true
            value = limited
        }

        if (resetValue) {
            this.ref.input.value = format(value)
            this.range.set({
                value: value,
            })
        }

        this.emit('change', {
            value,
        })
    }

    isValid() {
        return !this.error
    }

    getData() {
        if (!this._data) {
            const unit = this.element.querySelector('.RangeControl-inputUnit')
            this._data = {
                label: this.element.querySelector('.RangeControl-label').innerText.trim(),
                text: unit ? unit.innerText.trim() : '',
            }
        }

        const value = this.getValue()

        return {
            label: this._data.label,
            value: value,
            parsed: `${this._data.label} ${value} ${this._data.text}`.trim(),
        }
    }

    setOptions(options = {}) {
        if (!this.ready) {
            this.optionsQueue.push(options)
            return
        }

        const value = this.getValue()

        if ('translate' in options) {
            this.options.translate = options.translate
        }

        if ('range' in options) {
            this.range.set({
                min: options.range[0],
                max: options.range[1],
            })
        }

        if ('value' in options) {
            this.range.set(
                {
                    value: options.value,
                },
                true,
            )
        } else {
            this.range.set({
                value: value,
            })
        }
    }
}
